// Components
import Button, { ButtonVariant } from 'src/components/atoms/Button';
import { Checkbox } from 'src/components/atoms/Checkbox';
import { ChoicesContainer } from './styles';

// Types
import { CheckboxType } from 'src/components/atoms/Checkbox/types';

const ChoicesBox = ({
  name,
  isLoading,
  data,
  dataSelected,
  totalRows,
  onSelected,
  removeAll
}: {
  name: string;
  isLoading: boolean;
  data: CheckboxType[];
  dataSelected: CheckboxType[];
  totalRows?: number;
  onSelected: (content: boolean) => void;
  removeAll: () => void;
}) => {
  const totalAvailable = totalRows !== undefined ? totalRows : data.length;
  const isCheckAll =
    Boolean(data.length && dataSelected.length) && dataSelected.length === totalAvailable;

  return (
    <ChoicesContainer>
      <Checkbox
        name={`choices_${name}`}
        value="all"
        label="Select All"
        isNull={dataSelected.length > 0 && dataSelected.length !== data.length}
        isDisabled={data.length === 0 || isLoading}
        isChecked={isCheckAll}
        onClick={(obj) => {
          onSelected(obj.isChecked);
        }}
      />
      <Button
        name="button-clear-sorting"
        variant={ButtonVariant.ghost}
        onClick={(e) => {
          e.stopPropagation();
          removeAll();
        }}
      >
        Clear selection
      </Button>
    </ChoicesContainer>
  );
};

export default ChoicesBox;
